import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorkOrdersProducts(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCTS,
		options
	)
}

function _getWorkOrdersProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCT,
		options
	)
}

function _createWorkOrdersProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].CREATE_WORK_ORDERS_PRODUCT,
		options
	)
}

function _putWorkOrdersProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PUT_WORK_ORDERS_PRODUCT,
		options
	)
}

function _patchWorkOrdersProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PATCH_WORK_ORDERS_PRODUCT,
		options
	)
}

function _deleteWorkOrdersProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].DELETE_WORK_ORDERS_PRODUCT,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCTS]: _getWorkOrdersProducts,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCT]: _getWorkOrdersProduct,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].CREATE_WORK_ORDERS_PRODUCT]: _createWorkOrdersProduct,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PUT_WORK_ORDERS_PRODUCT]: _putWorkOrdersProduct,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PATCH_WORK_ORDERS_PRODUCT]: _patchWorkOrdersProduct,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].DELETE_WORK_ORDERS_PRODUCT]: _deleteWorkOrdersProduct,
}